import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import { renderCustomSwiperNav } from '../../carousel-navigation/index.js';
import '../../../../../node_modules/swiper/core/core.js';
import '../../../../../node_modules/swiper/shared/dom.js';
import Navigation from '../../../../../node_modules/swiper/modules/navigation/navigation.js';
import Pagination from '../../../../../node_modules/swiper/modules/pagination/pagination.js';
import { updateButtons } from './updateButtons.js';

const getGenericCarouselSettings = (_a, ctx) => {
    var _b, _c;
    var props = __rest(_a, []);
    const nav = (_b = ctx.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('carousel-navigation');
    const counter = (_c = nav === null || nav === void 0 ? void 0 : nav.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.swiper-counter');
    const isMulticomponent = ctx.componentType === 'multicomponent';
    const breakpoints = isMulticomponent
        ? {
            790: { slidesPerView: 2, spaceBetween: 24 },
        }
        : {
            768: { slidesPerView: 2.1, spaceBetween: 24 },
            800: { slidesPerView: 2.3, spaceBetween: 24 },
            900: { slidesPerView: 2.5, spaceBetween: 24 },
            1200: { slidesPerView: 3.2, spaceBetween: 24 },
            1366: { slidesPerView: 3, spaceBetween: 24 },
            1920: {
                slidesPerView: ctx.calcSlidesPerView(ctx.numberOfSlots),
                spaceBetween: 24,
            },
        };
    return {
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: props.nextEl,
            prevEl: props.prevEl,
            disabledClass: 'disabled',
        },
        pagination: {
            el: counter,
            type: 'custom',
            renderCustom: (swiper, current, total) => renderCustomSwiperNav(ctx.navTemplate, current, total),
        },
        on: {
            init: updateButtons,
            toEdge: updateButtons,
            fromEdge: updateButtons,
        },
        a11y: {
            prevSlideMessage: ctx.previousText,
            nextSlideMessage: ctx.nextText,
        },
        preloadImages: false,
        lazy: true,
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        speed: 600,
        spaceBetween: 16,
        breakpoints,
    };
};

export { getGenericCarouselSettings };
